'use client'

import { Overlay } from '@/components/Overlay'
import { Dialog, type DialogStore, useDisclosureStore } from '@ariakit/react'
import * as overlayStyles from '@/components/Overlay/Overlay.css'
import { useScrollbarOffset } from '@/hooks/useScrollLock'
import { Input } from '@/components/Search/Search'
import { Suspense, useEffect } from 'react'
import { theme } from '@/styles/theme.css'
import SearchResultsList, { SearchResultsListLoading } from '@/components/Law/SearchResultsList'
import { Stack } from '@christiankaindl/lyts'
import SearchFilters from '@/components/Search/SearchFilters'
import { useSearch } from '@/components/Search/SearchProvider'
import { create } from 'zustand'
// import { useNormContext } from '@/components/Norm/NormContext'

interface SearchOverlayStore {
  dialog: DialogStore | null
}

export const useSearchOverlay = create<SearchOverlayStore>()(() => ({
  dialog: null,
}))

export default function SearchOverlay () {
  const dialog = useDisclosureStore()

  useEffect(() => {
    if (useSearchOverlay.getState().dialog) {
      throw new Error('Multiple SearchOverlays registered')
    }
    useSearchOverlay.setState({ dialog })
    return () => { useSearchOverlay.setState({ dialog: null }) }
  }, [dialog])

  return (
    <Overlay>
      <Dialog
        store={dialog}
        className={overlayStyles.content}
        style={{
          zIndex: 1000,
          right: useScrollbarOffset(),
          animationDuration: '0ms',
        }}
        backdrop={<div className={overlayStyles.backdrop} />}
      >
        <div className={overlayStyles.contentInner} style={{ padding: 0, backgroundColor: 'white' }}>
          <SearchBar />
          <Stack style={{ padding: 12 }}>
            <Suspense fallback={<SearchResultsListLoading />}>
              <SearchFilters />
              <SearchResultsList />
            </Suspense>
          </Stack>
        </div>
      </Dialog>
    </Overlay>
  )
}

// const mappings = {
//   Rechtssatz: 'Rechtssatz',
//   Norm: 'Gesetz',
//   Paragraph: 'Paragraf',
//   Text: 'Entscheidung',
// }

function SearchBar () {
  const { setQuery } = useSearch()
  // const norm = useNormContext()
  // const documentTypeStr = (norm.Dokumenttyp && mappings[norm.Dokumenttyp]) ?? 'Dokument'
  return (
    <Input
      placeholder='Gesetz durchsuchen...'
      style={{
        borderRadius: '18px 18px 0px 0px',
        backgroundColor: 'white',
        maxWidth: 'unset',
        height: 52,
        border: 'none',
        position: 'sticky',
        top: 0,
        backdropFilter: 'blur(20px)',
        zIndex: 10,
        borderBottom: `1px solid ${theme.colors.borders.border1}`,
      }}
      onChange={(event) => {
        setQuery(event.currentTarget.value)
      }}
    />
  )
}
